import { Controller } from "@hotwired/stimulus"

// Usage:
// <div data-controller="auto-dismiss" data-auto-dismiss-timeout-value="5000">
//   ...
//   <button data-action="click->auto-dismiss#close">×</button>
// </div>
export default class extends Controller {
  static values = { timeout: { type: Number, default: 5000 } }

  connect() {
    // If data-auto-dismiss-timeout-value is set on element, it will be
    // picked up by Stimulus values API automatically.
    this.startTimer()
  }

  disconnect() {
    this.clearTimer()
  }

  startTimer() {
    this.clearTimer()
    if (this.timeoutValue > 0) {
      this._timer = setTimeout(() => this.close(), this.timeoutValue)
    }
  }

  clearTimer() {
    if (this._timer) {
      clearTimeout(this._timer)
      this._timer = null
    }
  }

  close() {
    this.clearTimer()
    if (this.element && this.element.parentNode) {
      this.element.parentNode.removeChild(this.element)
    }
  }
}

